import ToxicityGraph from './ToxicityGraph';

export default ToxicityGraph;
